import { gql } from '@apollo/client'
export const GET_ALL_PROVIDERS = gql`
  query GetAllProviders($limit: Int, $offset: Int, $searchQuery: String) {
    getAllProviders(limit: $limit, offset: $offset, searchQuery: $searchQuery) {
      count
      rows {
        id
        card_name
        card_code
        email
        logo
        phone
        rfc
        type
        typeSpanish
      }
    }
  }
`

export const GET_PROVIDER_BY_ID = gql`
  query GetProviderById($getProviderByIdId: Int!) {
    getProviderById(id: $getProviderByIdId) {
      id
      card_name
      card_code
      email
      phone
      logo
      rfc
      type
      typeSpanish
    }
  }
`

export const GET_TYPE_PROVIDERS = gql`
  query GetTypesForProvider {
    getTypesForProvider {
      label
      value
    }
  }
`

export const CREATE_PROVIDER = gql`
  mutation CreateProvider($provider: ProviderInput!) {
    createProvider(provider: $provider)
  }
`

export const UPDATE_PROVIDER = gql`
  mutation UpdateProvider($updateProviderId: Int!, $provider: ProviderInput!) {
    updateProvider(id: $updateProviderId, provider: $provider)
  }
`

export const DELETE_PROVIDER = gql`
  mutation DeleteProvider($id: Int!) {
    deleteProvider(id: $id)
  }
`
